import { Link } from 'react-router-dom';

/**
 * SmartLink
 * ----------
 * A single drop-in for homepage / marketing CTAs that output either a
 * same-origin path (preview, dev, or cross-layer in the same deployment)
 * or an absolute URL (production cross-origin — nymphe.co → nymphe.app).
 *
 * Relative path  → react-router <Link>   (SPA navigation, no full reload)
 * Absolute URL   → plain <a>             (cross-origin navigation)
 *
 * Accepts `to` exactly like <Link>. Any other prop (className, data-testid,
 * onClick, children, aria-*, target, rel, ...) is forwarded unchanged.
 */
export const SmartLink = ({ to, children, ...rest }) => {
  const isAbsolute = typeof to === 'string' && /^https?:\/\//i.test(to);
  if (isAbsolute) {
    return (
      <a href={to} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={to} {...rest}>
      {children}
    </Link>
  );
};

export default SmartLink;
